export const ATTACK_HEAD_PLAYER = 'ATTACK_HEAD_PLAYER'
export const ATTACK_LEFT_HAND_PLAYER = 'ATTACK_LEFT_HAND_PLAYER'
export const ATTACK_RIGHT_HAND_PLAYER = 'ATTACK_RIGHT_HAND_PLAYER'
export const ATTACK_BODY_PLAYER = 'ATTACK_BODY_PLAYER'
export const ATTACK_LEGS_PLAYER = 'ATTACK_LEGS_PLAYER'
export const DEFEND_HEAD_PLAYER = 'DEFEND_HEAD_PLAYER'
export const DEFEND_LEFT_HAND_PLAYER = 'DEFEND_LEFT_HAND_PLAYER'
export const DEFEND_RIGHT_HAND_PLAYER = 'DEFEND_RIGHT_HAND_PLAYER'
export const DEFEND_BODY_PLAYER = 'DEFEND_BODY_PLAYER'
export const DEFEND_LEGS_PLAYER = 'DEFEND_LEGS_PLAYER'
export const ATTACK_HEAD_ENEMY_PLAYER = 'ATTACK_HEAD_ENEMY_PLAYER'
export const ATTACK_LEFT_HAND_ENEMY_PLAYER = 'ATTACK_LEFT_HAND_ENEMY_PLAYER'
export const ATTACK_RIGHT_HAND_ENEMY_PLAYER = 'ATTACK_RIGHT_HAND_ENEMY_PLAYER'
export const ATTACK_BODY_ENEMY_PLAYER = 'ATTACK_BODY_ENEMY_PLAYER'
export const ATTACK_LEGS_ENEMY_PLAYER = 'ATTACK_LEGS_ENEMY_PLAYER'
export const DEFEND_HEAD_ENEMY_PLAYER = 'DEFEND_HEAD_ENEMY_PLAYER'
export const DEFEND_LEFT_HAND_ENEMY_PLAYER = 'DEFEND_LEFT_HAND_ENEMY_PLAYER'
export const DEFEND_RIGHT_HAND_ENEMY_PLAYER = 'DEFEND_RIGHT_HAND_ENEMY_PLAYER'
export const DEFEND_BODY_ENEMY_PLAYER = 'DEFEND_BODY_ENEMY_PLAYER'
export const DEFEND_LEGS_ENEMY_PLAYER = 'DEFEND_LEGS_ENEMY_PLAYER'
export const UNSET_ATTACK_HEAD_PLAYER = 'UNSET_ATTACK_HEAD_PLAYER'
export const UNSET_ATTACK_LEFT_HAND_PLAYER = 'UNSET_ATTACK_LEFT_HAND_PLAYER'
export const UNSET_ATTACK_RIGHT_HAND_PLAYER = 'UNSET_ATTACK_RIGHT_HAND_PLAYER'
export const UNSET_ATTACK_BODY_PLAYER = 'UNSET_ATTACK_BODY_PLAYER'
export const UNSET_ATTACK_LEGS_PLAYER = 'UNSET_ATTACK_LEGS_PLAYER'
export const UNSET_DEFEND_HEAD_PLAYER = 'UNSET_DEFEND_HEAD_PLAYER'
export const UNSET_DEFEND_LEFT_HAND_PLAYER = 'UNSET_DEFEND_LEFT_HAND_PLAYER'
export const UNSET_DEFEND_RIGHT_HAND_PLAYER = 'UNSET_DEFEND_RIGHT_HAND_PLAYER'
export const UNSET_DEFEND_BODY_PLAYER = 'UNSET_DEFEND_BODY_PLAYER'
export const UNSET_DEFEND_LEGS_PLAYER = 'UNSET_DEFEND_LEGS_PLAYER'
export const UNSET_ATTACK_HEAD_ENEMY_PLAYER = 'UNSET_ATTACK_HEAD_ENEMY_PLAYER'
export const UNSET_ATTACK_LEFT_HAND_ENEMY_PLAYER = 'UNSET_ATTACK_LEFT_HAND_ENEMY_PLAYER'
export const UNSET_ATTACK_RIGHT_HAND_ENEMY_PLAYER = 'UNSET_ATTACK_RIGHT_HAND_ENEMY_PLAYER'
export const UNSET_ATTACK_BODY_ENEMY_PLAYER = 'UNSET_ATTACK_BODY_ENEMY_PLAYER'
export const UNSET_ATTACK_LEGS_ENEMY_PLAYER = 'UNSET_ATTACK_LEGS_ENEMY_PLAYER'
export const UNSET_DEFEND_HEAD_ENEMY_PLAYER = 'UNSET_DEFEND_HEAD_ENEMY_PLAYER'
export const UNSET_DEFEND_LEFT_HAND_ENEMY_PLAYER = 'UNSET_DEFEND_LEFT_HAND_ENEMY_PLAYER'
export const UNSET_DEFEND_RIGHT_HAND_ENEMY_PLAYER = 'UNSET_DEFEND_RIGHT_HAND_ENEMY_PLAYER'
export const UNSET_DEFEND_BODY_ENEMY_PLAYER = 'UNSET_DEFEND_BODY_ENEMY_PLAYER'
export const UNSET_DEFEND_LEGS_ENEMY_PLAYER = 'UNSET_DEFEND_LEGS_ENEMY_PLAYER'
export const GET_ENEMY_STATE_FROM_WS = 'GET_ENEMY_STATE_FROM_WS'
